import { graphql, useStaticQuery } from "gatsby";

export const useSeoQuery = (keyword) => {
  const { allStrapiSeo } = useStaticQuery(graphql`
    query SeoQuery {
      allStrapiSeo {
        nodes {
          page_name
          meta_title
          meta_description {
            data {
              meta_description
            }
          }
          meta_keyword {
            data {
              meta_keyword
            }
          }
        }
      }
    }
  `);
  return allStrapiSeo?.nodes?.find((item) => item.page_name === keyword);
};
